import React, { useState } from "react"

import lowerCase from "lodash/lowerCase"
import PropTypes from "prop-types"

import { useTeeUpPage } from "../../../pages/TeeUpPage/TeeUpPageContext"
import { useGameplans } from "../hooks"
import { SuggestionsList } from "../molecules"

import { Block } from "./gameplanBlockStyles"

// TEEUP-LIFECYCLE fix (2026-07-04, QJ ruling, screenshot-verified problem): this is the FULL-WIDTH
// expanded content that WhenWhereCard.tsx mounts directly beneath its own collapsed section row
// (iPhone GameplansCard parity). It used to also render `GameplanHeader` (the type label + a
// "Suggest"/suggestion-count line) and `DecidedSuggestion` (the decided value/address + icon,
// itself clickable to its own SuggestionPopup) -- BOTH duplicated content the collapsed
// WhenWhereCard row already shows (its own label, its own decided value with its own popup
// click-through, its own suggestion count + pill strip), which was the reported "Where address
// renders twice" bug once GameplanSection stacked/expanded both columns. The expanded view now
// renders ONLY the actual added value: the suggestion ROWS (attribution, conflict labels,
// per-row popup, "+ Suggest" action) via SuggestionsList -- never the header/value again.
export const GameplanBlock = ({ type }) => {
  const [isNewest, setIsNewest] = useState(true)
  const { teeup } = useTeeUpPage()
  const lowerType = lowerCase(type)
  const { suggestions, decidedSuggestion } = useGameplans({
    teeup,
    type: lowerType,
    isNewest,
  })

  return (
    <Block data-testid={type}>
      {suggestions.length > 0 && (
        <SuggestionsList
          type={type}
          suggestions={suggestions}
          isNewest={isNewest}
          isDecidedSuggestion={!!decidedSuggestion}
          setIsNewest={setIsNewest}
        />
      )}
    </Block>
  )
}

GameplanBlock.propTypes = {
  type: PropTypes.string,
}
